const timestamps = new Map<string, number[]>();

export function checkRateLimit(key: string, maxAttempts: number, windowMs: number): boolean {
  const now = Date.now();
  const attempts = (timestamps.get(key) ?? []).filter((t) => now - t < windowMs);

  if (attempts.length >= maxAttempts) {
    return false;
  }

  attempts.push(now);
  timestamps.set(key, attempts);
  return true;
}

export function getRateLimitReset(key: string, windowMs: number): number {
  const attempts = timestamps.get(key);
  if (!attempts?.length) return 0;
  const oldest = Math.min(...attempts);
  return Math.max(0, Math.ceil((oldest + windowMs - Date.now()) / 1000));
}
